import { ReactComponent as SearchIcon } from "@preownedfront/lib-reowds/icons/24/search.svg";
import { t } from "i18next";
import { Link, useLocation, useHistory } from "react-router-dom";
import { PRODUCT_NICKNAME } from "src/constants/UrlConstants";
import { useScrollDirection } from "src/hooks/Utils/useScrollDirection";
import { ProfileShortcut } from "src/pages/Profile/ProfileShortcut/ProfileShortcut";
import { ROUTE_PATHS } from "src/utils/constants";
import { navigateToZaraHome } from "src/utils/navigation";
import useResponsive from "src/utils/useResponsive";
import { getClassnames } from "src/utils/utils";
import { useHeaderIconType } from "../utils/useHeaderIconType";
import CartCounterLink from "src/components/CartCounter/CartCounterLink";
import { useNavigationLogic } from "../utils/useNavigationLogic";
import { PreownedLogoButton } from "./PreownedLogoButton";
import ArrowBackButton from "../common/ArrowBackButton";
import { DismissButton } from "../common/DismissButton";
import { useAppState } from "src/hooks/state/use-app-state";
import { useImageSearchStore } from "src/store/useImageSearch/useImageSearchStore";
import { useGridFilterStore } from "src/store/useGridFilters/useGridFilterStore";

import "./preowned-header.scss";

const PreownedHeader = () => {
  const { pathname, state } = useLocation();
  const history = useHistory();
  const productNickname = state?.[PRODUCT_NICKNAME];
  const { WSXS, WS } = useResponsive();
  const { whiteBackGround } = useNavigationLogic();
  const { headerIconType } = useHeaderIconType();
  const { scrollDirection } = useScrollDirection();
  const RESET_FILTER = useGridFilterStore(state => state.RESET_SEARCH_FILTER)
  const SET_PENDING_SEARCH_UNIVERSE = useGridFilterStore(state => state.SET_PENDING_SEARCH_UNIVERSE)
  const originalSearchUniverseId = useGridFilterStore(state => state.originalSearchUniverseId)
  const { CLEAR_SEARCH, CLEAR_FILE } = useImageSearchStore((state) => state);
  const isMobile = WSXS;
  const isCategoryModalOpen = useAppState((state) => state.modals.categoryFilter);
  

  const classNameNavBar = getClassnames({
    ["nav-main-menu"]: pathname?.includes(`${ROUTE_PATHS.PRODUCTS}/`) && WS,
    ["nav"]: true,
    ["nav-background"]: whiteBackGround && WS,
    ["wm"]: WSXS,
    [scrollDirection]: WSXS,
  });

  const isProductPage =
    pathname?.includes(`${ROUTE_PATHS.PRODUCTS}/`) &&
    !pathname?.includes(ROUTE_PATHS.BUNDLE);

  const handleGoToSearch = () => {
    if (!isMobile) {
      const shouldRestoreOriginalSearchUniverse = pathname?.includes(ROUTE_PATHS.SEARCH);

      if (shouldRestoreOriginalSearchUniverse && originalSearchUniverseId !== undefined) {
        SET_PENDING_SEARCH_UNIVERSE(originalSearchUniverseId);
      }
    }
    RESET_FILTER();
    CLEAR_SEARCH();
    CLEAR_FILE();
    history.push(ROUTE_PATHS.SEARCH);
  };

  return (
    <header className={classNameNavBar} id="header-content">
      <ul className="nav__header">
        <li className="nav__icons__icon">
          {headerIconType === "arrow" ? (
            <ArrowBackButton noFunc={!!productNickname} isSmall />
          ) : (
            !(WS && isCategoryModalOpen) ? (
              <DismissButton
                ariaLabel={
                  headerIconType === "close"
                    ? t("call_alert_close")
                    : t("close_cart_button")
                }
                onClick={WSXS ? () => navigateToZaraHome() : undefined}
                isSmall
              />
            ) : null
          )}
        </li>
        <li className="nav__icons__icon">
          <div className="nav__icons__logo-text">
            <PreownedLogoButton />
            {isProductPage && (
              <>
                <h1 className="sr-only">Zara Pre-Owned</h1>
                <div className="nav__icons__logo-text__informative">
                  <p className="pds-body-s-highlight">
                    {t("informative-text-grid-1")}
                  </p>
                  <p className="pds-body-s-highlight">
                    {t("informative-text-grid-2")}
                  </p>
                </div>
              </>
            )}
          </div>
        </li>
      </ul>
      {!pathname?.includes(`${ROUTE_PATHS.SELL}/`) && (
      <nav>
        <ul className="nav__icons">
          <li>
            <div
              className="nav__icons__icon"
              role="button"
              tabIndex={0}
              aria-label={t("navigation_search")}
              onClick={handleGoToSearch}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") handleGoToSearch();
              }}
            >
              <SearchIcon className="nav__icons__wm-icon__svg" />
            </div>
          </li>
          <li>
            <ProfileShortcut className="nav__icons__icon" />
          </li>
          <li>
            <CartCounterLink />
          </li>
        </ul>
      </nav>
      )}
    </header>
  );
};

export default PreownedHeader;
